import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { DespesaService } from '../services/despesa.service';
import { ItemDespesaService } from '../services/item-despesa.service';
import { FornecedorService } from '../services/fornecedor.service';
import { VeiculoService } from '../services/veiculo.service';
import { ModeloVeiculoTipoDespesaService } from '../services/modelo-veiculo-tipo-despesa.service';
import { UnidadeMedidaService } from '../services/unidade-medida.service';
import { ManutencaoService } from '../services/manutencao.service';
import { OficinaService } from '../services/oficina.service';
import { PecaService } from '../services/peca.service';
import { TipoServicoService } from '../services/tipo-servico.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-manutencao-edit',
	templateUrl: './manutencao-edit.component.html',
	styleUrls: ['./manutencao-edit.component.css'],
	animations: [loadingFade]
})
export class ManutencaoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public manutencao_id = null;
	public manutencao = [];

	public formDespesa: FormGroup;
	public tipo_despesa_array = [];
	public veiculo_array: NgOption[] = [];
	public fornecedor_array = [];
	public unidade_medida_array = [];
	public tipo_manutencao = [
		{ tipo_manutencao_id: 1, tipo_manutencao_nome: 'Preventiva Externa' },
		{ tipo_manutencao_id: 2, tipo_manutencao_nome: 'Preventiva Interna' },
		{ tipo_manutencao_id: 3, tipo_manutencao_nome: 'Corretiva Externa' },
		{ tipo_manutencao_id: 4, tipo_manutencao_nome: 'Corretiva Interna' }
	];

	public modeloVeiculoTipoDespesa_array = [];
	public item_despesa_array = [];
	public oficinas = [];
	public pecas_array = [];
	public tipos_servicos = [];

	public qtde_char_descricao = 0;
	public veiculo;
	public quilometragem = 0;
	public total_pecas = 0;
	public total_servicos = 0;

	//filtro
	public despesa_valor___valorMin = null;
	public despesa_valor___valorMax = null;
	public despesa_data_compra___data_i = null;
	public despesa_data_compra___data_f = null;
	public veiculo_id___veiculo_id = null;	

	// datepickers
	public data_compra_dp;

		//acesso
		public usuario_perfil;
		public visualizar = true;
		public editar = false;

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private despesaSvc: DespesaService,
		private itemDespesaSvc: ItemDespesaService,
		private fornecedorSvc: FornecedorService,
		private modeloVeiculoTipoDespesaSvc: ModeloVeiculoTipoDespesaService,
		private unidadeMedidaSvc: UnidadeMedidaService,
		private manutencaoSvc: ManutencaoService,
		private oficinaSvc: OficinaService,
		private pecaSvc: PecaService,
		private tipoServicoSvc: TipoServicoService,
		private router: Router,
		private veiculoSvc: VeiculoService,
		private perfilUsuarioSvc: PerfilUsuarioService
	) { }

	ngOnInit() {


		this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {

				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "despesa_valor___valorMin": { 
						 this.despesa_valor___valorMin = loSplitValor[1];
						 break; 
					  } 
					  case "despesa_valor___valorMax": { 
						this.despesa_valor___valorMax = loSplitValor[1];
						 break; 
					  } 
					  case "despesa_data_compra___data_i": { 
						this.despesa_data_compra___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "despesa_data_compra___data_f": { 
						this.despesa_data_compra___data_f = loSplitValor[1];
						 break; 
					  }      
					  case "veiculo_id___veiculo_id": { 
						this.veiculo_id___veiculo_id = loSplitValor[1];
						 break; 
					  }                                                            
				   }
		
				  }
		
		
				}  

				this.manutencao_id = params.id;
				this.manutencaoSvc.getManutencao(params.id).then((data: any) => {

					this.preencheForm({
						manutencao_id: data.manutencao_id,
						usuario_id: this.authSvc.getUsuarioId(),
						tipo_manutencao_id: data.tipo_manutencao_id,
						veiculo_id: data.veiculo_id,
						oficina_id: data.oficina_id,
						manutencao_data_abertura: data.manutencao_data_abertura != null ? moment(data.manutencao_data_abertura).format('DD/MM/YYYY') : '',
						manutencao_hora_abertura: data.manutencao_hora_abertura,
						manutencao_data_conclusao: data.manutencao_data_conclusao != null ? moment(data.manutencao_data_conclusao).format('DD/MM/YYYY') : '',
						manutencao_hora_conclusao: data.manutencao_hora_conclusao,
						manutencao_solicitante: data.manutencao_solicitante,
						manutencao_aprovador: data.manutencao_aprovador,
						manutencao_descricao: data.manutencao_descricao,
						pecas: [],
						servicos: [],
					});


					if (data.despesa_descricao)
						this.qtde_char_descricao = data.despesa_descricao.length;

					for (let peca of data.pecas) {
						this.addPeca(peca.peca_id, peca.manutencao_peca_quantidade, peca.unidade_medida_id, peca.manutencao_peca_valor, peca.manutencao_peca_valor_total);
					}
					for (let servico of data.servicos) {
						this.addServico(servico.servico_id, servico.manutencao_servico_quantidade, servico.manutencao_servico_descricao, servico.manutencao_servico_valor, servico.manutencao_servico_valor_total);
					}
					this.calculaPecas();
					this.calculaServicos();

					this.loading = false;
				});
			}
			else {
				this.addPeca();
				this.addServico();
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formDespesa = this.fb.group({
			manutencao_id: '',
			usuario_id: this.authSvc.getUsuarioId(),
			tipo_manutencao_id: [null, Validators.required],
			veiculo_id: [null, Validators.required],
			oficina_id: null,
			manutencao_data_abertura: [null, Validators.required],
			manutencao_hora_abertura: null,
			manutencao_data_conclusao: [null, Validators.required],
			manutencao_hora_conclusao: null,
			manutencao_solicitante: ['', Validators.maxLength(100)],
			manutencao_aprovador: ['', Validators.maxLength(100)],
			manutencao_descricao: null,
			pecas: this.fb.array([]),
			servicos: this.fb.array([]),
		});

		this.pegaVeiculos();
		this.pegaFornecedores();
		this.pegaUnidadeMedida();
		this.pegaOficinas();
		this.pegaPecas();
		this.pegaTiposServicos();

		let campos_data = ['manutencao_data_abertura', 'manutencao_data_conclusao'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formDespesa.controls[campo].setValue(formatted);
				}
			});
		}
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			for (let veiculo of data) {
				if (veiculo.veiculo_isento == 'N') {
					dados.push({
						veiculo_id: veiculo.veiculo_id,
						veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					});
				}
			}
			this.veiculo_array = dados;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaFornecedores() {
		this.fornecedorSvc.getFornecedores('fornecedor_nome').then((data: any[]) => {
			this.fornecedor_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaModeloVeiculoTipoDespesa(modelo_veiculo_id) {
		this.modeloVeiculoTipoDespesaSvc.getModeloVeiculoTipoDesepesa(modelo_veiculo_id).then((data: any[]) => {
			this.modeloVeiculoTipoDespesa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaUnidadeMedida() {
		this.unidadeMedidaSvc.getUnidadesMedida().then((data: any[]) => {
			this.unidade_medida_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}
	
	pegaOficinas() {
		this.oficinaSvc.getOficinas().then((data: any[]) => {
			this.oficinas = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaPecas() {
		this.pecaSvc.getPecas().then((data: any[]) => {
			this.pecas_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaTiposServicos() {
		this.tipoServicoSvc.getTiposServico().then((data: any[]) => {
			this.tipos_servicos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formDespesa.setValue(dados);
	}

	enviaDespesa() {
		if (this.formDespesa.valid) {
			this.submitting = true;

			let toSend = this.formDespesa.value;
			toSend.manutencao_valor = this.total_pecas + this.total_servicos;
			if (this.manutencao_id === null) {
				this.manutencaoSvc.criaManutencao(toSend).then((data: any) => {
					Swal.fire({
						type: 'success',
						title: 'Manutenção cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/manutencao']);
						}
					});
				}).catch((err) => {
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else {
				this.manutencaoSvc.editaManutencao(toSend).then((data: any) => {
					Swal.fire({
						type: 'success',
						title: 'Manutenção cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/manutencao']);
						}
					});
				}).catch((err) => {
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formDespesa.controls) {
				let campo = this.formDespesa.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formDespesa.value.manutencao_descricao.length;
	}

	invalid(nome) {
		let input = this.formDespesa.get(nome);
		return input.touched && input.invalid;
	}

	createItemPeca(peca_id = null, manutencao_peca_quantidade = null, unidade_medida_id = null, manutencao_peca_valor = '', manutencao_peca_valor_total = '') {
		return this.fb.group({
			peca_id: [peca_id, [Validators.required]],
			manutencao_peca_quantidade: [manutencao_peca_quantidade, [Validators.required]],
			unidade_medida_id: [unidade_medida_id, [Validators.required]],
			manutencao_peca_valor: [manutencao_peca_valor, [Validators.required]],
			manutencao_peca_valor_total: [manutencao_peca_valor_total, [Validators.required]]
		})
	}

	addPeca(peca_id = null, manutencao_peca_quantidade = null, unidade_medida_id = null, manutencao_peca_valor = null, manutencao_peca_valor_total = null) {
		const despesas = this.formDespesa.get('pecas') as FormArray;
		if (peca_id != null && manutencao_peca_quantidade != null && unidade_medida_id != null && manutencao_peca_valor != null && manutencao_peca_valor_total != null) {
			despesas.push(this.createItemPeca(peca_id, manutencao_peca_quantidade, unidade_medida_id, manutencao_peca_valor, manutencao_peca_valor_total));
		}
		else {
			despesas.push(this.createItemPeca());
		}
	}

	removePeca(index) {
		const despesas = this.formDespesa.get('pecas') as FormArray;
		despesas.controls.length == 1 || despesas.removeAt(index);
		this.calculaPecas();
	}

	calculaPecas(i = null) {
		let pecas = this.formDespesa.get('pecas') as FormArray;
		let soma = 0;
		for (let peca of pecas.controls) {
			soma += peca.value['manutencao_peca_quantidade'] * peca.value['manutencao_peca_valor'];
		}
		this.total_pecas = soma;
		if (i != null) {
			pecas.at(i).get('manutencao_peca_valor_total').setValue(pecas.at(i).get('manutencao_peca_quantidade').value * pecas.at(i).get('manutencao_peca_valor').value);
		}
	}

	createItemServico(servico_id = null, manutencao_servico_quantidade = null, manutencao_servico_descricao = null, manutencao_servico_valor = '', manutencao_servico_valor_total = '') {
		return this.fb.group({
			servico_id: [servico_id, [Validators.required]],
			manutencao_servico_descricao: [manutencao_servico_descricao],
			manutencao_servico_quantidade: [manutencao_servico_quantidade, [Validators.required]],
			manutencao_servico_valor: [manutencao_servico_valor, [Validators.required]],
			manutencao_servico_valor_total: [manutencao_servico_valor_total, [Validators.required]]
		});
	}

	addServico(servico_id = null, manutencao_servico_quantidade = null, unidade_medida_id = null, manutencao_servico_valor = null, manutencao_servico_valor_total = null) {
		const despesas = this.formDespesa.get('servicos') as FormArray;
		if (servico_id != null && manutencao_servico_quantidade != null && unidade_medida_id != null && manutencao_servico_valor != null && manutencao_servico_valor_total != null) {
			despesas.push(this.createItemServico(servico_id, manutencao_servico_quantidade, unidade_medida_id, manutencao_servico_valor, manutencao_servico_valor_total));
		}
		else {
			despesas.push(this.createItemServico());
		}
	}

	removeServico(index) {
		const despesas = this.formDespesa.get('servicos') as FormArray;
		despesas.controls.length == 1 || despesas.removeAt(index);
		this.calculaServicos();
	}

	calculaServicos(i = null) {
		let servicos = this.formDespesa.get('servicos') as FormArray;
		let soma = 0;
		for (let servico of servicos.controls) {
			soma += servico.value['manutencao_servico_quantidade'] * servico.value['manutencao_servico_valor'];
		}
		this.total_servicos = soma;

		if (i != null) {
			servicos.at(i).get('manutencao_servico_valor_total').setValue(servicos.at(i).get('manutencao_servico_quantidade').value * servicos.at(i).get('manutencao_servico_valor').value);
		}
	}


	onClickVoltar(){

		let params = 'despesa_valor___valorMin=' + this.despesa_valor___valorMin;
		params += "&despesa_valor___valorMax=" + this.despesa_valor___valorMax;
		params += "&despesa_data_compra___data_i=" + this.despesa_data_compra___data_i;
		params += "&despesa_data_compra___data_f=" + this.despesa_data_compra___data_f;
		params += "&veiculo_id___veiculo_id=" + this.veiculo_id___veiculo_id;
	
		//this.router.navigate(['/home/manutencaofiltro/' + params]);

		this.router.navigate(['/home/manutencao']);
	
	  }
}
